export const internalLinks = {
    DEFINE: {NAME: "define", STEP: 0},
    TEMPLATE_WIZARD: {NAME: "create", STEP: 0},
    TARGET: {NAME: "target", STEP: 1},
    BUILD: {NAME: "build", STEP: 2},
    LAUNCH: {NAME: "launch", STEP: 4},
    SUMMARY: {NAME: "summary", STEP: 4},
};

export const ExcludeBreadcrumbsWithTemplateIdList = ['21'];
export const ExcludeLanguageSelectorWithTemplateIdList = ['21'];

export const URL_SURVEY_ID = "surveyId";
export const TQS_URL_SURVEY_ID = "tqssurveyid";
export const TW_URL_SURVEY_ID = "surveyid";
export const URL_TEMPLATE_ID = "templateId";